import { render, staticRenderFns } from "./salesCustomer.vue?vue&type=template&id=69c783a8&scoped=true"
import script from "./salesCustomer.vue?vue&type=script&lang=js"
export * from "./salesCustomer.vue?vue&type=script&lang=js"
import style0 from "./salesCustomer.vue?vue&type=style&index=0&id=69c783a8&prod&scoped=true&lang=css"
import style1 from "./salesCustomer.vue?vue&type=style&index=1&id=69c783a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c783a8",
  null
  
)

export default component.exports